import { render, staticRenderFns } from "./ClientCode.vue?vue&type=template&id=f5c225b6&scoped=true&"
import script from "./ClientCode.vue?vue&type=script&lang=js&"
export * from "./ClientCode.vue?vue&type=script&lang=js&"
import style0 from "./ClientCode.vue?vue&type=style&index=0&id=f5c225b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c225b6",
  null
  
)

export default component.exports